import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  connect(){
    console.log("Address controller is connected")
  }

  initGoogle(){
    console.log("google maps init and we know it")
    console.log(google)
  }
}
